import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import ClickOutside from "vue-click-outside";
import Skeleton from "./skeleton.vue";
import Icon from "@Shared/components/general/fa-icon.vue";
import { defineComponent } from "@vue/composition-api";
import ChangelogItem from "./changelog-item.vue";
import { getMainApi } from "@Shared/@Utils/ajax";
export default defineComponent({
  name: "ApplicationChangelog",
  components: {
    Icon,
    ChangelogItem,
    Skeleton
  },
  directives: {
    ClickOutside
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    applicationId: {
      type: Number,
      required: true
    },
    clientUsername: {
      type: String,
      required: true
    },
    agentUsername: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      isOpen: false,
      changelog: []
    };
  },
  computed: {},
  watch: {
    async show(value) {
      this.isOpen = value;
      if (value) {
        await this.loadChangelog();
      }
    }
  },
  methods: {
    async handleClose() {
      this.$emit("update:show", false);
    },
    handleClickOutside(e) {
      var _e$path$some, _e$path;
      const clickOnChangelogPopover = (_e$path$some = e == null ? void 0 : (_e$path = e.path) == null ? void 0 : _e$path.some(({
        className
      }) => className && _includesInstanceProperty(className).call(className, "changelog-popover"))) != null ? _e$path$some : {};
      if (!this.isOpen || clickOnChangelogPopover) return;
      this.handleClose();
    },
    async loadChangelog() {
      this.loading = true;
      const response = await getMainApi({}, `/client/${this.clientUsername}/application/${this.applicationId}/history`);
      this.changelog = response.applicationHistory;
      this.loading = false;
    }
  }
});